import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { setResponsiveMode } from "office-ui-fabric-react";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCheckSquare, faCoffee } from '@fortawesome/fontawesome-free-solid';

/* Services */
import { getUserLogged } from "../../services/loginClient";
import * as apiClient from "../../services/apiClient";
import Select from 'react-select'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loading from "../Loading/Loading";

/* Telerik */
import DropdownFilterCell from '../Shared/Telerik/DropdownFilterCell';
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column, GridNoRecords, GridToolbar } from "@progress/kendo-react-grid";
import { orderBy, filterBy } from "@progress/kendo-data-query";
import { Button } from '@progress/kendo-react-buttons';

/* Fechas */
import Cldr from 'cldrjs';
//import { IntlProvider, load, LocalizationProvider } from '@progress/kendo-react-intl';
import { IntlProvider, load } from '@progress/kendo-react-intl';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import weekData from 'cldr-core/supplemental/weekData.json';
// Español.
import numbers from 'cldr-numbers-full/main/es/numbers.json';
import currencies from 'cldr-numbers-full/main/es/currencies.json';
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json';
//import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json';
import dateFields from 'cldr-dates-full/main/es/dateFields.json';
// Inglés.
import numbersENGB from 'cldr-numbers-full/main/en/numbers.json';
import currenciesENGB from 'cldr-numbers-full/main/en/currencies.json';
import caGregorianENGB from 'cldr-dates-full/main/en/ca-gregorian.json';
//import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json';
import dateFieldsENGB from 'cldr-dates-full/main/en/dateFields.json';

// Machacar el formato inglés yankee al que queremos.
//dateFieldsENGB.main['en-GB'].dates.fields.day.displayName = 'dd';
//dateFieldsENGB.main['en-GB'].dates.fields.month.displayName = 'mm';
//dateFieldsENGB.main['en-GB'].dates.fields.year.displayName = 'yyyy';
caGregorianENGB.main['en'].dates.calendars.gregorian.dateFormats.short = 'dd/MM/yyyy';

// Cargar los datos CLDR
load(
    likelySubtags,
    weekData,
    currencies,
    currenciesENGB,
    numbers,
    numbersENGB,
    caGregorian,
    caGregorianENGB,
    //timeZoneNames,
    dateFields,
    dateFieldsENGB
);

/* shared */
import TooltipInput from '../Shared/TooltipInput';
import ModalMessage from '../Shared/ModalMessage';
import employees from "../Shared/data";
const subItemsField = "registros";
const expandField = "expanded";
import {
    removeIndiceFila,
    hayCambiosPendientes, setCambiosPendientes, removeCambiosPendientes,
    removeMockuserSession,
    setPeriodoSession, getPeriodoSession, removePeriodoSession,
    formatDate, addMonthsToDate,
    setFlag, getFlag
} from '../Shared/Shared.js';

/* CSS */
import '../../custom.css'
import './AdminPeriodos.css';

setFlag('isMenuColapsado', false);

/* Configuración grid */
// Paginación.
const initialDataState = {
    skip: 0,
    take: 25,
};
// Ordenación tabla.
const initialSort = [
    {
        field: "fecha_creacion",
        dir: "asc",
    },
];
// Filtros tabla.
const initialFilter = {
    logic: "and",
    filters: [],
};
// Anchura columnas.
const anchoColumna = {
    id: "70px",
    estado: "140px",
    codigoSociedad: "180px",
    nombreSociedad: "300px",
    fechaInicio: "210px",
    fechaFin: "210px",
    fechaCierre: "210px",
}

const AdminPeriodos = (props) => {
    const constantes = {
        operacion: {
            crear: 'I',
            actualizar: 'U',
            eliminar: 'D'
        },
        estado: {
            abierto: 'Abierto',
            cerrado: 'Cerrado'
        },
        dataState: {
            skip: 0,
            take: 10
        },
        idiomas: {
            es: { codigo: 'es-ES', abreviatura: 'es' },
            en: { codigo: 'en-EN', abreviatura: 'en' },
        }
    }

    const language = navigator.language.startsWith('es') ? 'es' : 'en';
    const [translations, setTranslations] = useState([]);
    const [persona, setPersona] = useState(null);
    const [userLogged, setUserLogged] = useState(getUserLogged());
    const [loading, setLoading] = useState(true);

    /* Tabla */
    const refGrid = React.useRef([]);
    const [registros, setRegistros] = useState([]);
    const [gridData, setGridData] = React.useState([]); //[...products].filter(i => i.estado != "Firmado"));
    const [gridPage, setGridPage] = React.useState(initialDataState);
    const [gridPageSizeValue, setGridPageSizeValue] = React.useState();
    const [sortData, setSortData] = React.useState(initialSort);
    const [filterData, setFilterData] = React.useState(initialFilter);
    /* Mensaje */
    const [message, setMessage] = useState('');
    const [messageTitle, setMessageTitle] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [messageStatus, setMessageStatus] = useState(false);
    const [messageHeaderBackground, setMessageHeaderBackground] = useState('');

    useEffect(() => {
        const GetTranslations = async () => {
            const labels = await apiClient.GetLabelsByFolderAndControllerAndLabelName(language, "TimesheetTasking", "AdminPeriodos", "adminPeriodos");
            const labels2 = await apiClient.GetLabelsByFolderAndControllerAndLabelName(language, "TimesheetTasking", "Report", "reportHours");
            let auxLabels = labels.concat(labels2)
            const data = await apiClient.GetTranslationsByLabels(language, auxLabels);

            setMessage((await data).filter(item => 'adminPeriodos.Loading' == item.label)[0].body);
            setLoading(true);

            setTranslations(data);
        };

        const GetScreenData = async () => {
            var req = getReq();
            var persona = await apiClient.GetPersonaData(language, req);
            await btnBuscar_Click();
            //var datosIniciales = await apiClient.GetDatosInicialesReport1(language, req);
            //var opcionesSociedades = getOpcionesSociedad(datosIniciales.sociedades);
            //var opcionesBusinessUnits = getBusinessUnits(datosIniciales.businessUnits);

            setPersona(persona);
            //setOpcionesSociedades(opcionesSociedades);
            //setOpcionesBusinessUnits(opcionesBusinessUnits);
            setLoading(false);
        };

        const OcultarMenu = () => {
            // Establezco un timeout de 500ms porque de lo contrario no puedo determinar
            // si el menú lateral está o no colapsado.
            setTimeout(() => {
                var isFlagColapsado = getFlag('isMenuColapsado');

                if (!isFlagColapsado) {
                    setFlag('isMenuColapsado', true);

                    if (document.getElementById('sidebar-css').offsetWidth > 100) {
                        document.getElementById('menu_open').click();
                    }
                }
            }, 500);
        }

        const EliminarMarcaAguaLicenciaCaducada = () => {
            setTimeout(() => {
                $('div[style*="data:image/png;base64,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"]').remove();
                $('span:contains("activate your license")').closest('div').remove();
            }, 500);
        };

        GetTranslations();
        setLoading(true);
        GetScreenData();
        setLoading(false);
        OcultarMenu();
        //enterInsert();

        //EliminarMarcaAguaLicenciaCaducada();
    }, []);

    /********************************************************************************* Configuración tabla */

    /************************************************************************** Fin configuración tabla */
    /************************************************************************** Eventos botones */
    const btnBuscar_Click = async (event) => {
        setLoading(true);
        let req = getReq();
        let datos = await getData();

        setLoading(false);
    };

    const getData = async () => {
        let req = getReq();
        let catalogo = await apiClient.GetAdminPeriodosCatalogo(language, req);
        catalogo.forEach((item) => {
            item.fechaInicio = new Date(item.fechaInicio);
            item.fechaFin = new Date(item.fechaFin);
            item.fechaCierre = new Date(item.fechaCierre);
        });
        setRegistros(catalogo);
        setGridData(catalogo);

        return { catalogo: catalogo }
    };
    /************************************************************************** Fin eventos botones */
    /************************************************************************** Filtros */

    /************************************************************************** Fin filtros */
    /************************************************************************** Eventos producidos en la tabla */
    // Paginación tabla.
    const pageChange = (event) => {
        const targetEvent = event.targetEvent;
        const take = targetEvent.value === "All" ? gridData.length : event.page.take;

        if (targetEvent.value) {
            setGridPageSizeValue(targetEvent.value);
        }

        setGridPage({
            ...event.page,
            take,
        });
    };

    /************************************************************************** Fin eventos producidos en la tabla */
    /************************************************************************** Resto de funciones */
    const getTranslation = (label) => {
        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    const getReq = () => {
        return {
            email: userLogged.mail,
            token: userLogged.token
        };
    }
    /************************************************************************** Fin resto de funciones */
    /************************************************************************** Funciones tabla Telerik */

    /************************************************************************** Fin funciones tabla Telerik */
    /************************************************************************** Utils */
    function formatDateNumber(num) {
        return num.toString().padStart(2, '0');
    }

    const formatDateString = (date) => {
        var formatDate = [formatDateNumber(date.getDate()), formatDateNumber(date.getMonth() + 1), date.getFullYear()].join('/');
        return formatDate;
    };

    const formatDateDataBase = (date) => {
        var dateToFormat = new Date(date);
        var formatDate = [dateToFormat.getFullYear(), formatDateNumber(dateToFormat.getMonth() + 1), formatDateNumber(dateToFormat.getDate())].join('-');
        return formatDate;
    };

    const getLanguage = () => {
        let idioma = (constantes.idiomas.hasOwnProperty(language)) ? constantes.idiomas[language] : constantes.idiomas['en'];

        return idioma;
    };

    /************************************************************************** Fin Utils */
    const enterInsert = () => {
        const maxId = gridData.reduce((acc, current) => Math.max(acc, current.ProductID || 0), 0);
        const dataItem = {
            id: maxId + 1,
            inEdit: true
        };
        const newProducts = [dataItem, ...gridData];
        setData(newProducts);
    };

    const CustomCell = ({ tdProps, children, color }) => {
        return tdProps ? <td {...tdProps} style={{
            ...tdProps.style,
            backgroundColor: color
        }}>
            {children}
        </td> : null;
    };

    const MyInputCustomCell = props => <CustomCell {...props} color="#f97e6d" />;
    const MyNumericCustomCell = props => <CustomCell {...props} color="#90ab86" />;
    const MyDateCustomCell = props => <CustomCell {...props} color="#a1cec5" />;
    const MyBooleanCustomCell = props => <CustomCell {...props} color="#fac390" />;

    const enterEdit = dataItem => {
        const newData = gridData.map(item => item.id === dataItem.id ? {
            ...item,
            inEdit: true
        } : item);
        setGridData(newData);
    };
    const save = async (dataItem) => {
        setLoading(true);
        console.log(registros);

        let year = dataItem.fechaCierre.getFullYear();
        let month = String(dataItem.fechaCierre.getMonth() + 1).padStart(2, '0');
        let day = String(dataItem.fechaCierre.getDate()).padStart(2, '0');
        let hours = String(dataItem.fechaCierre.getHours()).padStart(2, '0');
        let minutes = String(dataItem.fechaCierre.getMinutes()).padStart(2, '0');
        let seconds = String(dataItem.fechaCierre.getSeconds()).padStart(2, '0');
        let nuevaFechaCierre = `${year}-${month}-${day}T23:59:59`;

        let periodo = {
            id: dataItem.id,
            idEstado: dataItem.idEstado,
            sociedad: dataItem.sociedad,
            fechaInicio: dataItem.fechaInicio,
            fechaFin: dataItem.fechaFin,
            fechaCierre: nuevaFechaCierre,
            nombre_sociedad: dataItem.nombreSociedad,
            label_estado: dataItem.label_estado
        }

        let req = getReq();
        let resultado = await apiClient.SetAdminPeriodo(req, periodo);

        if (resultado) {
            registros.filter(item => item.id == dataItem.id)[0].fechaCierre = dataItem.fechaCierre;
            const newData = gridData.map(item => item.id === dataItem.id ? {
                ...dataItem,
                inEdit: undefined
            } : item);
            setRegistros(registros);
            setGridData(newData);

            setMessageTitle(getTranslation("adminPeriodos.OperationResult"));
            setMessageContent(getTranslation("adminPeriodos.OperationSaved"));
            setMessageStatus(true);
            setMessageHeaderBackground("bg-success");
        } else {
            setMessageTitle(getTranslation("adminPeriodos.OperationResult"));
            setMessageContent(getTranslation("adminPeriodos.OperationNoSaved"));
            setMessageStatus(true);
            setMessageHeaderBackground("bg-danger");
        }

        setLoading(false);
    };
    const cancel = dataItem => {
        if (!dataItem.id) {
            setGridData(gridData.filter(item => item.id !== undefined));
        } else {
            const regOriginal = registros.filter(item => item.id == dataItem.id)[0];
            //const regModificado = gridData.filter(item => item.id == dataItem.id)[0];
            //regModificado.fechaCierre = new Date(regOriginal.fechaCierre);

            const newData = gridData.map(item => item.id === dataItem.id ? {
                ...regOriginal,//gridData.find(p => p.id === dataItem.id),
                inEdit: false
            } : item);
            //console.log(gridData);
            setGridData(newData);
        }
    };
    const remove = dataItem => {
        setGridData(gridData.filter(item => item.id !== dataItem.id));
    };
    const itemChange = event => {
        const { value, field } = event;

        if (!field) return;

        const newData = gridData.map(item => item.id === event.dataItem.id ? {
            ...item,
            [field]: value
        } : item);

        setGridData(newData);
    };


    const MyCommandCell = props => <td>
        {!props.dataItem.inEdit ? <>
            <Button themeColor={'primary'} onClick={() => enterEdit(props.dataItem)}>
                Edit
            </Button>
            {/*<Button onClick={() => window.confirm('Confirm deleting ' + props.dataItem.fechaCierre) && remove(props.dataItem)}>
                Remove
            </Button>*/}
        </> : <>
            <Button themeColor={'primary'} onClick={() => save(props.dataItem)}>
                {props.dataItem.id ? getTranslation('adminPeriodos.Update') : 'Add'}
            </Button>
            <Button className="ml-1" onClick={() => cancel(props.dataItem)}>
                {/*{props.dataItem.ud ? 'Cancel' : 'Discard changes'}*/}
                {getTranslation('adminPeriodos.Cancel')}
            </Button>
        </>}
    </td>;

    return (

        <Row between="xs" className="">
            <Col xs={12}>
                {
                    loading &&
                    <Loading show={loading} message={message} />
                }

                <ModalMessage
                    title={messageTitle}
                    message={messageContent}
                    show={messageStatus}
                    setMessageStatus={setMessageStatus}
                    headerBackground={messageHeaderBackground}
                    btnCloseText={getTranslation("adminPeriodos.Close")}
                />

                <section>
                    <h5>{getTranslation('utilisation.Title')}</h5>
                </section>

                <section>
                    <Row between="xs" className="">
                        <Col xs={6}>
                            <button id="btnBuscar" className="btn mr-1" onClick={btnBuscar_Click}>{getTranslation('adminPeriodos.Search')}</button>
                        </Col>
                    </Row>

                    <Row between="xs" className="mt-1">
                        <Col xs={12} className="p-0">
                            <div className="user-report-grid ag-theme-alpine" style={{ overflowX: 'auto' }}>

                                <IntlProvider locale={language}>
                                    <Grid
                                        ref={refGrid}
                                        //style={{ height: "400px", }}
                                        headerClassName="tabla-header"
                                        className="treelist-espacio k-header-portafirmas"
                                        data={orderBy(filterBy(gridData.slice(gridPage.skip, gridPage.take + gridPage.skip), filterData), sortData)}
                                        filterable={true}
                                        filter={filterData}
                                        onFilterChange={(e) => setFilterData(e.filter)}
                                        skip={gridPage.skip}
                                        take={gridPage.take}
                                        total={gridData.length}
                                        pageable={{
                                            buttonCount: 4,
                                            pageSizes: [10, 25, 50, 100, "All"],
                                            pageSizeValue: gridPageSizeValue,
                                            responsive: false
                                        }}
                                        onPageChange={pageChange}
                                        sortable={true}
                                        sort={sortData}
                                        onSortChange={(e) => {
                                            setSortData(e.sort);
                                        }}
                                        expandField="expanded"
                                        sizeColumnsToFit={true}

                                        editField="inEdit"
                                        onItemChange={itemChange}
                                        cells={{
                                            edit: {
                                                text: MyInputCustomCell,
                                                numeric: MyNumericCustomCell,
                                                boolean: MyBooleanCustomCell,
                                                date: MyDateCustomCell
                                            }
                                        }}>

                                        <GridNoRecords>There is no data available</GridNoRecords>
                                        {/*<Column field="id"*/}
                                        {/*    title={<div class="form-check" style={{ verticalAlign: 'bottom' }}>*/}
                                        {/*        <input type="checkbox" className="form-check-input mt-2" checked={allSelected} onChange={onHeaderSelectionChange} role="button" />*/}
                                        {/*        <label class="form-check-label"></label>*/}
                                        {/*    </div>}*/}
                                        {/*    filterable={false}*/}
                                        {/*    sortable={false}*/}
                                        {/*    headerClassName="k-header-portafirmas"*/}
                                        {/*    className="text-center align-items-center"*/}
                                        {/*    width={anchoColumna.checkbox}*/}
                                        {/*    cell={(props) => <CommandCellCheckbox checked={props.dataItem.seleccionado} id={props.dataItem.id} onChange={onChangeCheckbox} className="small" />}*/}
                                        {/*/>*/}
                                        <Column field="id"
                                            title={'Id'}
                                            width={anchoColumna.id}
                                            headerClassName="center-wrap k-header-portafirmas"
                                            className="text-center small"
                                            orderable={true}
                                            filterable={false}
                                            editable={false}
                                        />
                                        <Column field="idEstado"
                                            title={getTranslation('adminPeriodos.Status')}
                                            width={anchoColumna.estado}
                                            headerClassName="k-header-portafirmas"
                                            className="small"
                                            editable={false}
                                            cell={(props) => <td className={`k-command-cell text-left ${props.className}`}>{getTranslation(props.dataItem.label_estado)}</td>}
                                        />
                                        <Column field='sociedad'
                                            title={getTranslation('adminPeriodos.Company')}
                                            width={anchoColumna.codigoSociedad}
                                            headerClassName="center-wrap k-header-portafirmas"
                                            className="text-center small"
                                            editable={false}
                                        />
                                        <Column field='nombre_sociedad'
                                            title={getTranslation('adminPeriodos.CompanyName')}
                                            width={anchoColumna.nombreSociedad}
                                            headerClassName="center-wrap k-header-portafirmas"
                                            className="text-left small"
                                            editable={false}
                                        />
                                        <Column field="fechaInicio"
                                            title={getTranslation('adminPeriodos.DateStart')}
                                            width={anchoColumna.fechaInicio}
                                            headerClassName="center-wrap k-header-portafirmas"
                                            className="text-center small"
                                            filter="date"
                                            editable={false}
                                            format="{0:dd/MM/yyyy HH:mm:ss}"
                                        />
                                        <Column field="fechaFin"
                                            title={getTranslation('adminPeriodos.DateEnd')}
                                            width={anchoColumna.fechaFin}
                                            className="text-center small"
                                            filter="date"
                                            editable={false}
                                            format="{0:dd/MM/yyyy HH:mm:ss}"
                                        />
                                        <Column field="fechaCierre"
                                            title={getTranslation('adminPeriodos.DateClose')}
                                            width={anchoColumna.fechaCierre}
                                            className="text-center small"
                                            filterable={false}
                                            editor="date"
                                            format="{0:dd/MM/yyyy HH:mm:ss}"
                                        />
                                        <Column
                                            width="200px"
                                            reorderable={false}
                                            filterable={false}
                                            cell={MyCommandCell}
                                        />
                                    </Grid>
                                </IntlProvider>
                            </div>
                        </Col>
                    </Row>
                </section>
            </Col>
        </Row>
    );
}

export default AdminPeriodos;